/**
 * Plain-language explanation for an offer the SYSTEM closed (Jason,
 * 2026-10-20): an auto-declined offer must not read like the other member
 * passed on it ("Not a fit this time"), and must not be attributed to them in
 * the history. The stored reason strings vary by writer
 * (functions/cleanupMatches.js, functions/autoDeclineOtherOffers.js), so they
 * are mapped to one sentence each here.
 */
export function isAutoDeclined(offer) {
  if (!offer) return false;
  if (offer.autoDeclinedAt) return true;
  return (offer.history || []).some((e) => e && e.type === 'auto_decline');
}

export function autoDeclineReasonText(offer) {
  const entry = (offer?.history || []).filter((e) => e && e.type === 'auto_decline').pop();
  const raw = `${offer?.declinedReason || ''} ${entry?.message || ''}`.toLowerCase();
  if (raw.includes('changed which offers')) {
    return 'The owner changed which offers this listing accepts, so this offer was closed automatically.';
  }
  if (raw.includes('deactivated') || raw.includes('inactive')) {
    return 'The owner made this listing inactive, so this offer was closed automatically.';
  }
  if (raw.includes('removed') || raw.includes('deleted')) {
    return 'The owner removed this listing, so this offer was closed automatically.';
  }
  if (raw.includes('accepted')) {
    return 'Another offer on this pedal was accepted, so this one was closed automatically.';
  }
  return 'The pedal is no longer available, so this offer was closed automatically.';
}
